export class MenuTypeModel {
    menu_no: number
    menu_option: string
    route: string
    icon: string
    children: MenuTypeModel[]

    constructor(
        menu_no: number,
        menu_option: string,
        route: string,
        icon: string,
        children: MenuTypeModel[]
    ) {
        this.menu_no = menu_no
        this.menu_option = menu_option
        this.route = route
        this.icon = icon
        this.children = children
    }
}